"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultConfig = exports.configs = void 0;
/*
    Currency format configurations. Following to this document:
    https://docs.google.com/document/d/19p3rUA6eXvHyIsXosiepCEno9AnDahhYdUpFORASNT0/edit
*/
exports.configs = {
    IDR: {
        symbol: 'Rp',
        pattern: '%s %a',
        numberOfDecimal: 0,
        separator: {
            grouping: '.',
            decimal: ',',
        },
    },
    MYR: {
        symbol: 'RM',
        pattern: '%s %a',
        numberOfDecimal: 2,
        separator: {
            grouping: ',',
            decimal: '.',
        },
    },
    PHP: {
        symbol: '₱',
        pattern: '%s %a',
        numberOfDecimal: 2,
        separator: {
            grouping: ',',
            decimal: '.',
        },
    },
    SGD: {
        symbol: 'SGD',
        pattern: '%s %a',
        numberOfDecimal: 2,
        separator: {
            grouping: ',',
            decimal: '.',
        },
    },
    THB: {
        symbol: 'THB',
        pattern: '%s %a',
        numberOfDecimal: 2,
        separator: {
            grouping: ',',
            decimal: '.',
        },
    },
    VND: {
        symbol: 'VND',
        pattern: '%a %s',
        numberOfDecimal: 0,
        separator: {
            grouping: '.',
            decimal: ',',
        },
    },
    AUD: {
        symbol: 'AU$',
        pattern: '%s%a',
        numberOfDecimal: 2,
        separator: {
            grouping: ',',
            decimal: '.',
        },
        isAllowedToBeRounded: true,
    },
    USD: {
        symbol: 'USD',
        pattern: '%s %a',
        numberOfDecimal: 2,
        separator: {
            grouping: ',',
            decimal: '.',
        },
    },
    EUR: {
        symbol: '€',
        pattern: '%s %a',
        numberOfDecimal: 2,
        separator: {
            grouping: ',',
            decimal: '.',
        },
    },
    JPY: {
        symbol: '円',
        pattern: '%a%s',
        numberOfDecimal: 0,
        separator: {
            grouping: ',',
            decimal: '.',
        },
    },
    KRW: {
        symbol: 'KRW',
        pattern: '%s %a',
        numberOfDecimal: 0,
        separator: {
            grouping: ',',
            decimal: '.',
        },
    },
    CNY: {
        symbol: 'CNY',
        pattern: '%s %a',
        numberOfDecimal: 2,
        separator: {
            grouping: ',',
            decimal: '.',
        },
    },
    CHF: {
        symbol: 'CHF',
        pattern: '%s %a',
        numberOfDecimal: 2,
        separator: {
            grouping: ',',
            decimal: '.',
        },
    },
    CAD: {
        symbol: 'CAD',
        pattern: '%s %a',
        numberOfDecimal: 2,
        separator: {
            grouping: ',',
            decimal: '.',
        },
    },
    NZD: {
        symbol: 'NZD',
        pattern: '%s %a',
        numberOfDecimal: 2,
        separator: {
            grouping: ',',
            decimal: '.',
        },
    },
    INR: {
        symbol: 'INR',
        pattern: '%s %a',
        numberOfDecimal: 2,
        separator: {
            grouping: ',',
            decimal: '.',
        },
    },
    TWD: {
        symbol: 'TWD',
        pattern: '%s %a',
        numberOfDecimal: 0,
        separator: {
            grouping: ',',
            decimal: '.',
        },
    },
    HKD: {
        symbol: 'HKD',
        pattern: '%s %a',
        numberOfDecimal: 2,
        separator: {
            grouping: ',',
            decimal: '.',
        },
    },
    KHR: {
        symbol: 'KHR',
        pattern: '%s %a',
        numberOfDecimal: 2,
        separator: {
            grouping: ',',
            decimal: '.',
        },
    },
    SAR: {
        symbol: 'SAR',
        pattern: '%s %a',
        numberOfDecimal: 2,
        separator: {
            grouping: ',',
            decimal: '.',
        },
    },
    TRY: {
        symbol: 'TRY',
        pattern: '%s %a',
        numberOfDecimal: 2,
        separator: {
            grouping: ',',
            decimal: '.',
        },
    },
    BRL: {
        symbol: 'BRL',
        pattern: '%s %a',
        numberOfDecimal: 2,
        separator: {
            grouping: ',',
            decimal: '.',
        },
    },
    GBP: {
        symbol: 'GBP',
        pattern: '%s %a',
        numberOfDecimal: 2,
        separator: {
            grouping: ',',
            decimal: '.',
        },
    },
};
// Currency symbol will use 3 letter code
exports.defaultConfig = {
    pattern: '%s %a',
    numberOfDecimal: 0,
    separator: {
        grouping: ',',
        decimal: '.',
    },
};
